import { Icon, Tooltip } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './download-icon-button.scss';

export interface DownloadIconButtonProps {
    onClick?: () => void;
    disabled?: boolean;
}

const DownloadIconButton = (props: DownloadIconButtonProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div className="download-icon-button">
            <Icon>
                <Tooltip title={t('tooltips.download') ?? ''} aria-label="download">
                    <div className="download-icon-button--icon" onClick={props.onClick} />
                </Tooltip>
            </Icon>
        </div>
    );
};

export default DownloadIconButton;
